module.exports = __webpack_public_path__ + "img/img3.5255e105.svg";